import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { SenderRegistration as SENDER_ADD } from 'Components/Api/RoundPayDMTAPI';
import { FetchDetailsForPincode as FETCH_DETAILS_FOR_PINCODE } from 'Components/Api/UsersApi';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import SearchIcon from 'Components/SvgButtons/SearchIcon';
import { Container, Grid, Paper, Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import AutoSubmitPincode from 'Components/Helper/AutoSubmitPincode';
import {
    MESSAGE_CLOSE_AFTER,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';
import { useLocation } from 'react-router-dom';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const SenderAdd = () => {
    const classes = commonStyle();
    const history = useHistory();
    const location = useLocation();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const Mobile = location?.state?.Mobile;

    const ActiveDMTName = location?.state?.DMTName;
    const [formObject, setFormObject] = useState({
        Mobile: Mobile,
        Name: '',
        Address: '',
        Pincode: ''
    });

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        if (loading) {
            setLoading(false);
            return;
        }

        var request = {
            PinCode: values.Pincode,
            Mobile: values.Mobile,
            Name: values.Name,
            Address: values.Address,
            DMTName: ActiveDMTName
        };

        var requestObj = JSON.stringify(request);

        setLoading(true);
        setIsError(false);

        var response = await SENDER_ADD(requestObj);
        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            setLoading(false);
            return;
        }
        resetForm(formObject);

        var data = JSON.parse(response.data);

        if (data.IsOTPRequired === true) {
            setIsError(true);
            setSeverity('success');
            setResponseMessage(data.Message);
            var param_2 = {
                Mobile: values.Mobile,
                DMTName: ActiveDMTName
            };
            history.push('/ROP_SenderVerify', param_2);

            return;
        }

        setIsError(true);
        setSeverity('success');
        setResponseMessage(data.Message);
    };

    const select = () => {
        setFormObject({
            ...formObject,
            Mobile: Mobile,
            Name: ''
        });
    };

    const FetchDetails = async (values, setFieldValue) => {
        var request = {
            Pincode: values.Pincode
        };
        var requestObj = JSON.stringify(request);

        setLoading(true);
        setIsError(false);

        var response = await FETCH_DETAILS_FOR_PINCODE(requestObj);

        if (!response.isAuthorized) LOGOUT();

        setLoading(false);
        setIsError(true);
        setSeverity('success');

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }

        var data = JSON.parse(response.data);

        setFieldValue(
            'Address',
            data.CityName + ',' + data.District + ',' + data.State
        );
    };

    useEffect(() => {
        select();
    }, []);

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string().required(PLEASE_PROVIDE_VALID + 'mobile'),
        Name: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'name')
            .min(8, PLEASE_PROVIDE_VALID + 'at least 8 length name'),
        Address: Yup.string().required(PLEASE_PROVIDE_VALID + 'address'),
        Pincode: Yup.string().required(PLEASE_PROVIDE_VALID + 'pincode')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <AutoSubmitPincode
                                        callback={() => {
                                            FetchDetails(values, setFieldValue);
                                        }}
                                    />
                                    <h2 className={classes.PaperHead_h2}>
                                        Sender Add
                                    </h2>
                                    <Grid item xs={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialNumberField
                                                        label="Mobile"
                                                        name="Mobile"
                                                        type="Mobile"
                                                        length={10}
                                                        readOnly={true}
                                                        placeholder="Mobile"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Name"
                                                        name="Name"
                                                        type="text"
                                                        placeholder="Name"
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={9}
                                                    lg={9}
                                                >
                                                    <MaterialNumberField
                                                        label="Pin code"
                                                        name="Pincode"
                                                        type="text"
                                                        length={6}
                                                        title="Pin code"
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={3}
                                                    lg={3}
                                                >
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        endIcon={<SearchIcon />}
                                                        className={
                                                            classes.CustomPrimaryButtonStyle
                                                        }
                                                        onClick={() => {
                                                            FetchDetails(
                                                                values,
                                                                setFieldValue
                                                            );
                                                        }}
                                                        style={{
                                                            marginLeft: '10px'
                                                        }}
                                                    ></Button>
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Address"
                                                        name="Address"
                                                        type="text"
                                                        placeholder="Address"
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>

                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                            >
                                                <Button
                                                    type="submit"
                                                    title="Add"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loading}
                                                >
                                                    Add
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </Button>

                                            <Button
                                                type="reset"
                                                title="Cancel"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                                onClick={(e) => {
                                                    var param_2 = {
                                                        Mobile: values.Mobile,
                                                        DMTName: ActiveDMTName
                                                    };
                                                    history.push(
                                                        '/ROP_DMTSenderSearch',
                                                        param_2
                                                    );
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Form>
                            </Grid>
                        </Grid>
                    );
                }}
            />
        </CustomContainer>
    );
};
